module.exports = __webpack_public_path__ + "img/MP.7393673d.svg";